/**
 * @copyright © 2021 株式会社レボルシオン
 */

/**
 * autocomplete=off
 */
$('form').attr('autocomplete', 'off');

/**
 * ロードイベントに追加
 */
window.addEventListener('load', function () {
    /**
     * back-to-top
     */
    let pagetop = $('#page-top');
    $('.page-content').on('scroll', function () {
        if ($(this).scrollTop() > 1) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.on('click', function () {
        $('.page-content').animate({
            scrollTop: 0
        }, 250);
    });
});
